// https://research.arizona.edu/faq/what-do-you-mean-when-you-say-use-title-case-proposalproject-titles
const TYPICALLY_NON_CAPITALIZED_WORDS = new Set([
  'and',
  'as',
  'but',
  'for',
  'if',
  'nor',
  'or',
  'so',
  'yet',
  'a',
  'an',
  'the',
  'as',
  'at',
  'by',
  'for',
  'in',
  'of',
  'off',
  'on',
  'per',
  'to',
  'up',
  'via',
]);

/**
 * Converts a string to title case (excludes capitalization of certain words).
 */
export function titleCase(str: string) {
  const words = str.split(' ');
  const captalizedWords = words.map((word, index) => {
    const isFirstWord = index === 0;
    const isLastWord = index === words.length - 1;

    if (!shouldCapitalizeWord(word, isFirstWord, isLastWord)) {
      return word.toLowerCase();
    }

    return capitalizeWordForTitleCase(word);
  });

  return captalizedWords.join(' ');
}

function capitalizeWordForTitleCase(word: string) {
  // handle title case capitalization for hyphenated words
  if (word.includes('-')) {
    const wordPieces = word.split('-');
    return wordPieces
      .map((wordPiece, index) => {
        const isFirstWord = index === 0;
        const isLastWord = index === wordPieces.length - 1;

        if (!shouldCapitalizeWord(wordPiece, isFirstWord, isLastWord)) {
          return wordPiece.toLowerCase();
        }

        return capitalizeFirstLetterOfWord(wordPiece);
      })
      .join('-');
  }

  return capitalizeFirstLetterOfWord(word);
}

function capitalizeFirstLetterOfWord(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

function shouldCapitalizeWord(
  word: string,
  isFirstWord: boolean,
  isLastWord: boolean
) {
  // typically non-capitalized words are capitalized if they are the first or last word
  return (
    !TYPICALLY_NON_CAPITALIZED_WORDS.has(word) || isFirstWord || isLastWord
  );
}
